import { useSetting, useAssignSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { ENABLE_RETAILER_SHIPPING_PREFERENCE_PAGE_230908 } from "@faire/web-api--source/indigofair/settings/ENABLE_RETAILER_SHIPPING_PREFERENCE_PAGE_230908";
export var useSettingEnableRetailerShippingPreferencePage = function() {
    return useSetting(ENABLE_RETAILER_SHIPPING_PREFERENCE_PAGE_230908, false);
};
export var useAssignEnableRetailerShippingPreferencePage = function() {
    return useAssignSetting(ENABLE_RETAILER_SHIPPING_PREFERENCE_PAGE_230908);
};
